import React from 'react';
import DatePicker from 'react-datepicker';
import DateFormat from 'constants/date_format';

const Date = ({
  className,
  value,
  onChange,
  disabled,
  id,
  viaAddSessionModal,
}) => (
  <div className="EventSessionForm-field">
    <label htmlFor="date-picker">{t('common.date')} *</label>
    <DatePicker
      id="date-picker"
      selected={value}
      aria-label={disabled ? 'Date Picker Disabled' : `Date Selected: ${value}`}
      aria-required="true"
      dateFormat={DateFormat.fixed.SHORT_MONTH_DAY_YEAR}
      onChange={viaAddSessionModal ? onChange : e => onChange(e, id)}
      className="NewInput NewInput--white NewInput--fw"
      disabled={disabled}
      required
      readOnly
    />
  </div>
);

export default Date;
